// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const PersonIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M12 1.5c3.26 0 5.91 2.65 5.91 5.91s-2.65 5.92-5.91 5.92-5.92-2.65-5.92-5.92C6.08 4.15 8.73 1.5 12 1.5" />
      <path
        d="M14.77 14.41H9.34c-3.02 0-5.55 2.54-5.55 5.56v.36c0 1.2.96 2.17 2.17 2.17h12.07c1.2 0 2.3-.84 2.17-2.17v-.36c.12-3.02-2.41-5.56-5.43-5.56"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default PersonIcon;
